

































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class Error extends Vue {
  @Prop() public text?: string;
  @Prop() public errorVisibility: boolean;

  @Watch('errorVisibility')
  public onErrorVisibilityChanged(isVisible: boolean): void {
    if (isVisible) this.$nextTick(() => (this.$refs.errorDialog as HTMLElement).focus());
  }
}
